<template>
  <div>
    <div class="sunshine-port">
      <Crumbs :info="info" :title="navList[0]" />
      <div class="port-container">
        <div class="port-nav">
          <MenuComBToC :navList="navList" />
        </div>
        <div class="port-content">
          <!-- 书写内容区域 -->
          <div class="content-nav">
            <ul class="nav-title">
              <li
                v-for="(item, index) in tabList"
                :key="index"
                :class="[
                  item.isFlex ? 'full-title' : '',
                  idx === index ? 'active-li' : ''
                ]"
                @click="idx = index"
              >
                {{ item.label }}
              </li>
            </ul>
            <div class="content-text">
              <div v-if="idx === 0" class="advantage-text">
                <h2>服务对象</h2>
                <p>所有跨境电商平台、独立站卖家的境内直邮发货业务，含国际快递、邮政小包、物流专线等。</p>
                <p>1.收款方式为个人收账或离岸公司账户；</p>
                <p>2.采购无进项发票、海外费用无发票，公司无法正常纳税；</p>
                <p>3.公司无报关数据；</p>
                <p>4.公司无经营数据、融资难；</p>
                <h2>业务优势</h2>
                <p>1.沉淀数据。通过报关可将卖家平台交易数据按跨境电商报关数据统计到企业名下，企业可纳入跨境电商企业行业管理，享受跨境电商企业政策，便于股权融资和债权融资。</p>
                <p>2.业务合规。通过业务合规降低监管风险。卖家无进项发票可申请增值税无票免征和所得税核定征收，以极低的税率实现税务合规；</p>
                <p>3.无痛转换。全程无纸化线上申报，平台可采用表格导入或系统对接方式导入数据，提供全程保姆式服务可使卖家业务转化便捷；</p>
                <p>4.通关便捷。9610出口业务可采用“清单核放、汇总申报”，并可申请四位海关编码简化申报，提高清关效率；</p>
                <p>5.阳光结汇。企业可凭电子交易数据直接向银行申请收结汇，境外发生的费用可与出口货款进行轧差结算，简化企业付汇手续，降低换汇成本；</p>
                <p>6.争取奖补。协助企业争取各地政府的跨境电商奖励和补贴政策；</p>
                <h2>服务内容和流程</h2>
                <h3>1.定制合规化方案</h3>
                <p>根据企业业务情况，确认企业跨境电商转型申报业务类型和税收申报类型。</p>
                <h3>2.资质办理</h3>
                <p>平台为客户开设账户，确定服务专员。根据企业业务需求，协助办理电商企业注册认证的5个监管机构共11项前置审批事项办理。</p>
                <h3>3.口岸对接</h3>
                <p>平台对接客户业务开展口岸的本地国际贸易单一窗口或公服平台，协助申请DXP和数字证书，完成海关申报系统对接。对接客户的物流公司和口岸跨境电商监管中心。</p>
                <h3>4.汇总申报</h3>
                <p>按月度导出汇总统计单/汇总报关单，提供企业免/退税依据，供企业进行税务申报。</p>
                <h3>5.完成收结汇</h3>
                <p>平台对接银行和第三方支付机构，提供报关数据，帮助企业以较低的手续费结汇到公司账户。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuComBToC from "./common/menuComBToC";
import Crumbs from "../SunShine/common/Crumbs.vue";
import { navList,flowTabList } from "../../../model/bToC";
export default {
  components: {
    MenuComBToC,
    Crumbs
  },
  data() {
    return {
      info: {},
      navList,
      tabList:flowTabList,
      idx: 0
    };
  },
  created() {
    const path = this.$route.fullPath;
    const index = navList.findIndex(item => item.path === path);
    if (index !== -1) {
      this.info = navList[index];
    }
  }
};
</script>

<style scoped>
.nav-title {
  display: flex;
  height: 50px;
  background: #eef0f4;
  border-radius: 8px 8px 0px 0px;
  line-height: 50px;
  width: 100%;
  border-bottom: 3px solid #D3D3D3;
  margin-bottom: 30px;
}
.nav-title .full-title {
  flex: 1;
}
.nav-title li {
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  padding-left: 25px;
  padding-right: 10px;
  cursor: pointer;
}
.nav-title .active-li {
  border-radius: 8px 8px 0px 0px;
  background: #F47310;
  color: #fff;
}
.content-nav {
  width: 816px;
  margin: 0 auto;
}
.port-nav {
  margin-right: 21px;
}
.port-container {
  width: 1200px;
  height: 1500px;
  margin: 0 auto;
  display: flex;
  padding: 34px 30px;
  border: 1px solid #d3d3d3;
  margin-top: 30px;
  margin-bottom: 186px;
}
.port-content {
  flex: 1;
}
.nav-title li:hover {
    border-radius: 8px 8px 0px 0px;
    background: #F47310;
    color: #fff;
}
.port-content h2 {
  height: 38px;
  font-size: 30px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #34373b;
  line-height: 38px;
  display: block;
  margin-bottom: 34px;
}
.port-content p {
  text-indent: 2em;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 34px;
  margin-bottom: 34px;
}
.advantage-text p{
  text-indent: 0;
  margin: 0;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 38px;
}
.advantage-text h3 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/BToC/Platform.vue